import Vue from 'vue';
import App from '@/App';
import router from '@/router/router';
import store  from '@/store/store';
import axios from 'axios';
import qs from 'qs';
import md5 from 'js-md5';
import echarts from 'echarts';
import {Alert, Confirm, Toast, Loading} from 'wc-messagebox';
import moment from 'moment';
import 'moment/locale/zh-cn';

import fetch from '@/util/axios/fetch';
import global_ from '@/globalConfig/globalConfig';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';

import "@/assets/js/perfect-scrollbar.jquery";
import "@/assets/css/perfect-scrollbar.css";

import 'wc-messagebox/style.css';
import '@/assets/css/style.css';
import '@/assets/css/login.css';

/****wc-messagebox 快捷提示框***/
Vue.use(Toast, {
    location: 'center' // 默认在底部
});
Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Loading);

let bus = new Vue();
Vue.prototype.$moment  = moment;
Vue.prototype.$axios   = axios;
Vue.prototype.$qs      = qs;
Vue.prototype.$echarts = echarts;
Vue.prototype.$md5     = md5;
Vue.prototype.$fetch   = fetch;
Vue.prototype.bus      = bus;
Vue.prototype.global_  = global_;

new Vue({
	el: '#app',
	router,
    store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js